import { getApiLanguage } from '../config/apiLanguage';

const en = {
  // Shared
  cancel: 'Cancel',
  continue: 'Continue',
  back: 'Back',
  done: 'Done',
  okay: 'Okay',
  delete: 'Delete',
  loading: 'Loading…',
  website: 'Website',
  email: 'Email',
  phone: 'Phone',
  password: 'Password',
  openInMaps: 'Open in maps',

  // Home filter (H-02)
  feedFilter: 'Feed filter',
  favoritesOnly: 'Show only favorites (saved profiles)',
  locationFilter: 'Location type',
  filterAll: 'All',
  filterFixedAddress: 'Fixed address',
  filterGpsBased: 'GPS-based',
  filterAllHint: 'Fixed and live locations',
  filterFixedHint: 'Profiles with a fixed address',
  filterGpsHint: 'Profiles with a live / GPS location',

  // Public VISI contacts (P-06)
  contactSocial: 'Contact & social',
  socialsSection: 'Socials',
  contactSection: 'Contact',
  noContacts: 'No contact details',
  playVideo: 'Play video',
  selectAction: 'Select your action',
  directCall: 'Direct call',
  sendSms: 'Send SMS',
  openEmail: 'Open email',
  openWebsite: 'Open website',
  openLink: 'Open link',
  copyValue: 'Copy',
  copied: 'Copied',
  closeAction: 'Close',

  // Delete account (A-02)
  deleteAccount: 'Delete account',
  deleteAccountWarnTitle: 'Delete your account?',
  deleteAccountWarnBody:
    'This permanently removes your ME account and data. Active VISI subscriptions are managed in the App Store or Google Play and are not cancelled automatically.',
  deleteAccountReasonTitle: 'Select a reason',
  deleteAccountReasonHelp:
    'We tend to get better all the time. Please help us improve by selecting a reason.',
  deleteAccountReasonLabel: 'Reason',
  deleteAccountMessageLabel: 'Optional message',
  deleteAccountConfirmTitle: 'Confirm deletion',
  deleteAccountConfirmBody: 'This cannot be undone. Your account will be removed immediately.',
  deleteAccountNeedReason: 'You need to select a reason',
  deleteAccountFailed: 'Could not delete account.',
  deleteAccountFarewellTitle: 'Goodbye',
  next: 'Next',

  // Subscription (V-14)
  subscription: 'Subscription',
  subscriptionInfo:
    'Purchases happen in the iOS/Android apps. This page shows server status; manage billing in the store.',
  subscriptionStatus: 'Status',
  subscriptionActive: 'Active',
  subscriptionCanceled: 'Canceled',
  subscriptionFree: 'Free',
  subscriptionNoPlan: 'No subscription',
  subscriptionPlan: 'Plan',
  subscriptionFreePlan: 'Free plan',
  subscriptionUpgradeHint: 'Upgrade in the mobile app to publish your VISI profile',
  subscriptionSlots: 'Up to {n} VISI profile(s) visible',
  subscriptionBenefits: 'Subscription benefits',
  subscriptionStart: 'Started',
  subscriptionEnd: 'Ends',
  subscriptionProduct: 'Product',
  linkedBusinesses: 'Linked businesses',
  promoterCodes: 'Promoter codes',
  manageAppStore: 'App Store subscriptions',
  managePlayStore: 'Google Play subscriptions',
  subscriptionRenews: 'Renews',
  subscriptionPrice: 'Price',
  subscriptionPlanDetail: '{slots} VISI + {promoters} Promoter',
  subscriptionMonth: 'month',
  subscriptionYear: 'year',
  privacyPolicyTitle: 'Privacy policy',
  privacyPolicyAccept: 'Accept and continue',
  privacyPolicyScrollHint: 'Scroll to the bottom of the policy to enable Accept.',
  none: '—',

  // Language
  language: 'Language',
  languageHint: 'UI language is stored locally and passed to API requests.',

  // Appearance
  appearance: 'Appearance',
  appearanceHint: 'Choose light or dark, or follow your device setting. Saved on this device only.',
  appearanceSystem: 'System',
  appearanceLight: 'Light',
  appearanceDark: 'Dark',

  // Primary navigation
  navHome: 'Home',
  navSearch: 'Search',
  navLists: 'Lists',
  navProfile: 'Profile',
  navSettings: 'Settings',
  navMap: 'Maps',
  navCreate: 'Create',
  navGuest: 'Guest',
  navAccount: 'Account',

  // Sidebar promo box
  promoTitle: 'Visible where you are.',
  promoBody: 'Create your VISI profile and connect with people around you.',
  promoCta: 'Learn more',

  // Home
  homeComposer: 'What’s on your mind?',
  homeTabForYou: 'For you',
  homeTabNotifications: 'Notifications',
  homeFeedFilters: 'Feed filters',
  homeFeedEmptyTitle: 'No VISIs in your feed',
  homeFeedEmptyBody: 'Tap + to choose categories, or search for people and places to follow.',
  homeUpdatesLoading: 'Loading updates…',
  homeUpdatesEmptyTitle: 'No updates yet',
  homeUpdatesEmptyBody: 'Favorites and list saves surface activity here.',
  homeUpdatesFailed: 'Failed to load updates',
  homeAddCategoryTitle: 'Add interest category',
  homeAddCategoryLabel: 'Category',
  homeAddCategoryEmpty: 'All available categories are already in your list, or data is still loading.',
  homeAddCategoryFailed: 'Could not add category',
  homeAddCategoryLoadFailed: 'Could not load categories.',
  homeManageCategoriesTitle: 'Your categories',
  homeManageCategoriesHint: 'Tap to select or deselect. Done saves your Home interests.',
  homeManageCategoriesSearch: 'Search categories',
  homeManageCategoriesEmpty: 'No categories match your search.',
  homeManageCategoriesFailed: 'Could not save categories',
  homeManageCategoriesAria: 'Manage categories',
  add: 'Add',
  adding: 'Adding…',
  saving: 'Saving…',
  homeAiResultsFor: 'Results for: "{q}"',
  homeAiAsking: 'Asking AI for: "{q}"…',
  homeAiNoBusinesses: 'No businesses available to search. Please select a category first.',
  homeAiFailed: 'Failed to get results from AI. Please try again.',
  homeAiNoMatch: 'AI couldn’t find any matching proposals for your query: "{q}"',

  // Companion column
  companionSearch: 'Search VisiMe',
  companionUpNext: 'Up next',
  companionSeeAll: 'See all',
  companionUpNextEmpty: 'Follow Home categories — Up next fills with top saved VISIs from them.',
  companionLists: 'Your lists',
  companionListsEmpty: 'Save VISIs into lists to find them later.',
  companionOpenLists: 'Open lists',
  companionVisis: 'Your VISIs',
  companionNoVisis: 'No VISI profiles yet',
  companionVisiStats: '{total} profiles · {visible} visible',
  companionAddNew: 'Add new',
  companionHelpLegal: 'Help & legal',
  companionHelpCenter: 'Help center',
  companionReport: 'Report a problem',
  companionPrivacy: 'Privacy and security',

  // VISI information page
  visiInfoNavTitle: 'What is VISI?',
  visiInfoHeroKicker: 'VisiMe explained',
  visiInfoHeroTitle: 'A VISI makes you visible where you are.',
  visiInfoHeroBody:
    'Your ME account is your private account. A VISI is your public profile: it shows what you offer, where you are and how people can reach you — on a fixed address or with a live location.',
  visiInfoWhatTitle: 'What a VISI is',
  visiInfoWhatBody:
    'A VISI is a public profile for a person, a business, a club or a project. It carries your name, categories, description, photos, contact details and location, and it appears in the feed of people nearby who follow your categories.',
  visiInfoMeVsVisiTitle: 'ME account vs VISI profile',
  visiInfoMeVsVisiBody:
    'The ME account is free and private: you browse, save lists and follow categories. A VISI profile is published and can be found by others. One ME account can hold several VISI profiles, depending on your subscription.',
  visiInfoLocationTitle: 'Fixed address or live location',
  visiInfoLocationBody:
    'A VISI with a fixed address always stays at its place — a shop, an office, a practice. A VISI with a live location moves with you, which suits markets, food trucks, tradespeople and events. You choose the mode per profile.',
  visiInfoDiscoveryTitle: 'How people find you',
  visiInfoDiscoveryBody:
    'People pick the categories they care about and see matching VISIs nearby, sorted by distance. They can save you to a list, mark you as a favourite and open your contact details, website or map entry in one tap.',
  visiInfoStepsTitle: 'Create a VISI in three steps',
  visiInfoStep1Title: 'Pick the category',
  visiInfoStep1Body: 'Category and subcategories decide in whose feed your VISI appears.',
  visiInfoStep2Title: 'Describe and illustrate',
  visiInfoStep2Body: 'Name, description, logo, cover images and contact details make the profile complete.',
  visiInfoStep3Title: 'Set the location',
  visiInfoStep3Body: 'Choose a fixed address or a live location, then publish the profile.',
  visiInfoSubscriptionTitle: 'Subscription and visibility',
  visiInfoSubscriptionBody:
    'Publishing a VISI needs an active subscription. Purchases run through the App Store or Google Play; this website shows the current status of your account.',
  visiInfoCtaTitle: 'Ready for your own VISI?',
  visiInfoCtaBody: 'Set up your profile now — you can edit every detail later.',
  visiInfoCtaButton: 'Create VISI',

  // Shared actions & list modals
  save: 'Save',
  clear: 'Clear',
  close: 'Close',
  rename: 'Rename',
  submit: 'Submit',
  share: 'Share',
  report: 'Report',
  saved: 'Saved',
  saveToList: 'Save to list',
  addToList: 'Add to list',
  manageLists: 'Manage lists',
  folderNoListsYet: 'No lists yet. Create one under Bookmarks.',
  addedToList: 'Added to {name}',
  couldNotAdd: 'Could not add',
  couldNotLoadLists: 'Could not load lists',
  listItemsCount: '{n} items',
  reported: 'Reported.',
  reportFailed: 'Report failed',
  reportVisi: 'Report VISI',
  businessNotFound: 'Business not found',
  failedLoadBusiness: 'Failed to load business',
  businessIdRequired: 'Business ID is required',
  tabRecommended: 'Recommended',
  tabSamePerson: 'Same person',
  qrCode: 'QR code',
  shareProfileAria: 'Share profile',
  qrCodeAria: 'QR code',
  reportAria: 'Report',
  languageEnglish: 'English',
  languageGerman: 'Deutsch',

  // Settings hub
  settingsGroupAccount: 'Account',
  settingsGroupBilling: 'Billing',
  settingsGroupPreferences: 'Preferences',
  settingsGroupDataPrivacy: 'Data & privacy',
  settingsGroupSupport: 'Support',
  settingsGroupLegal: 'Legal',
  settingsConfirmEmail: 'Confirm email',
  settingsConfirmEmailSub: 'Verify your email address',
  settingsLocation: 'Location',
  settingsLocationSub: 'GPS, network approx, or fixed address',
  settingsMaps: 'Maps',
  settingsMapsSub: 'Preferred map provider',
  settingsChangePassword: 'Change password',
  settingsChangePasswordSub: 'Update your login password',
  settingsSubscriptionSub: 'Manage via App Store / Play',
  settingsNotifications: 'Notifications',
  settingsNotificationsSub: 'Push, email, SMS, marketing',
  settingsSearchHistory: 'Search history',
  settingsSearchHistorySub: 'Clear recent searches',
  settingsDownloadData: 'Download your data',
  settingsDownloadDataSub: 'Request an export by email',
  settingsPrivacySecurity: 'Privacy and security',
  settingsPrivacySecuritySub: 'Policies and account controls',
  settingsRequest: 'Request',
  settingsPrivacyPolicy: 'Privacy policy',
  settingsTermsOfService: 'Terms of service',
  settingsLogout: 'Log out',
  settingsLogoutTitle: 'Log out?',
  settingsLogoutBody: 'You can sign back in anytime with your email.',
  settingsClearHistoryTitle: 'Clear search history?',
  settingsClearHistoryBody: 'This removes your recent search queries from this account.',
  settingsClearHistory: 'Clear',
  settingsNotSignedIn: 'Not signed in.',
  settingsClearHistoryFailed: 'Could not clear history.',
  settingsDownloadFailed: 'Request failed. Try again later.',
  settingsDownloadSuccess: 'If your email is on file, you will receive export instructions shortly.',

  // Bookmarks / lists
  bookmarksListCountOne: '{n} list',
  bookmarksListCountMany: '{n} lists',
  bookmarksCreateListAria: 'Create list',
  bookmarksSortNameAz: 'Name (A-Z)',
  bookmarksSortDateCreated: 'Date Created',
  bookmarksSortBusinessCount: 'Business Count',
  bookmarksSortLabelAz: 'A-Z',
  bookmarksSortLabelDate: 'Date',
  bookmarksSortLabelCount: 'Count',
  bookmarksNoListsTitle: 'No lists yet',
  bookmarksNoListsBody: 'Create a list to organize your favorite VISIs',
  bookmarksCreateList: 'Create list',
  bookmarksListOptionsAria: 'List options',
  bookmarksCreateNewList: 'Create new list',
  bookmarksListName: 'List name',
  bookmarksListNamePlaceholder: 'Friends, Work, Favorites',
  bookmarksRenameList: 'Rename list',
  bookmarksDeleteList: 'Delete list',
  bookmarksDeleteListBody: 'Are you sure you want to delete this list? The VISIs inside will not be deleted.',
  visiCountOne: '{n} VISI',
  visiCountMany: '{n} VISIs',

  // Search
  searchPlaceholder: 'Search VISI, Categories...',
  searchAdvanced: 'Advanced',
  searchAdvancedAria: 'Advanced search',
  searchTabVisi: 'VISI',
  searchTabCategories: 'Categories',
  searchRecent: 'Recent',
  searchClearAll: 'Clear all',
  searchEmptyTitle: 'Search VISIs',
  searchEmptyBody: 'Start typing to find businesses and categories',
  searchNoVisisFor: 'No VISIs found for "{q}"',
  searchSuggested: 'Suggested',
  searchNoCategoriesFor: 'No categories found for "{q}"',
  searchNoCategoriesAvailable: 'No categories available',

  // My profile
  myProfileTitle: 'My profile',
  myProfileSignInTitle: 'Sign in to view your profile',
  myProfileLogin: 'Log in',
  meAccount: 'ME ACCOUNT',
  myProfileAccountHint: 'Your personal account. Edit details anytime — this is separate from your public VISI profiles.',
  myProfileEditAccountAria: 'Edit account',
  myProfileSettingsAria: 'Settings',
  myProfileAccountFallback: 'Account',
  visiProfilesSection: 'VISI PROFILES',
  myProfileNoVisisYet: 'No VISI profiles yet',
  myProfileVisiCountOne: '{total} profile · {visible} visible',
  myProfileVisiCountMany: '{total} profiles · {visible} visible',
  myProfileMakeFirstVisible: 'Make first VISI visible',
  myProfileNoneVisibleWarning: 'None of your VISIs are visible. Turn on Visible so others can find you.',
  myProfileWithPromoterCode: 'With Promoter Code',
  myProfileLoadVisisFailed: 'Could not load your VISI profiles.',
  myProfileNoPublicVisisTitle: 'No public VISIs yet',
  myProfileNoPublicVisisBody: 'Add a VISI profile so others can find you.',
  myProfileVisiColumn: 'Visi',
  myProfileVisibleColumn: 'Visible',
  myProfileEditVisiAria: 'Edit VISI',
  myProfileQrAria: 'QR code',
  myProfileHideTestProfiles: 'Hide test profiles',
  myProfileShowTestProfiles: 'Show {n} test profiles',
  myProfileEditAccount: 'Edit account',
  myProfileChangePhoto: 'Change profile picture',
  myProfileFirstName: 'First name*',
  myProfileLastName: 'Last name',
  myProfileBirthday: 'Birthday',
  myProfileFirstNameMin: 'First name must be at least 2 characters.',
  myProfileSaveFailed: 'Could not save profile.',
  myProfileMaxVisibleReached: 'You have reached the maximum number of VISI profiles that can be visible at the same time.',
  myProfileVisibilityFailed: 'Could not update visibility.',
  myProfilePromoterTitle: 'Enter promoter code',
  myProfilePromoterHint: 'Use a promoter code for special onboarding benefits.',
  myProfilePromoterCode: 'Promoter code',
  myProfilePromoterInvalid: 'Invalid promoter code.',
  myProfilePromoterVerifyFailed: 'Could not verify promoter code.',

  // Header
  headerAskProposals: 'Ask about proposals…',
  headerSearchAria: 'Search',

  // Login & password reset
  loginWelcome: 'Welcome to VisiMe',
  loginOrRegisterTitle: 'Sign in or register',
  loginSignInTitle: 'Sign in',
  loginSubtitle: 'Sign in to access local services',
  loginContinue: 'Continue',
  loginEmailLabel: 'Email address',
  loginEditEmail: 'Edit',
  loginEmailCheckFailed: 'Could not verify this email. Please try again.',
  loginTermsHintBeforeTerms: 'When you create an account, you agree to our',
  loginTermsLink: 'Terms of Use',
  loginTermsHintMiddle: 'You can read our',
  loginPrivacyLink: 'Privacy Policy',
  loginTermsHintAfterPrivacy: ' to learn how we process your data.',
  loginImprint: 'Imprint',
  loginPrivacyPolicy: 'Privacy Policy',
  loginShowPassword: 'Show password',
  loginHidePassword: 'Hide password',
  loginFillAllFields: 'Please fill in all fields',
  loginInvalidEmail: 'Please enter a valid email address',
  loginFailed: 'Login failed. Please try again.',
  loginForgotPassword: 'Forgot Password?',
  loginSignIn: 'Sign In',
  registerTitle: 'Register',
  registerSubmit: 'Register',
  registerFirstName: 'First name',
  registerLastName: 'Last name',
  registerBirthday: 'Date of birth',
  registerBirthdayPlaceholder: 'DD.MM.YYYY',
  registerBirthdayHint: 'You must be at least 16 years old.',
  registerBirthdayInvalid: 'Please enter a valid date of birth (DD.MM.YYYY).',
  registerPasswordHint: 'Your password must be at least 8 characters long.',
  registerBirthdayStepTitle: 'Date of birth',
  registerPasswordRules: 'Password must be 8–40 characters and include upper, lower, and a number or symbol.',
  registerFailed: 'Registration failed. Please try again.',
  loginOrContinueWith: 'or',
  loginContinueGoogle: 'Continue with Google',
  loginContinueApple: 'Continue with Apple',
  socialLoginFailed: 'Social sign-in failed. Please try again.',
  socialLoginEmailRequired: 'Google did not provide an email for this account.',
  socialAppleNotConfigured: 'Apple sign-in is not configured for this environment.',
  socialBirthdayTitle: 'Your birthday',
  socialBirthdaySubtitle: 'VisiMe requires you to be at least 16 years old.',
  socialBirthdayLabel: 'Birthday',
  socialBirthdayContinue: 'Continue',
  socialBirthdayRequired: 'Please enter your birthday.',
  socialBirthdayFailed: 'Could not save your birthday. Please try again.',
  forgotBackToLogin: 'Back to Login',
  forgotTitle: 'Reset Password',
  forgotSubtitle: "Enter your email address and we'll send you a link to reset your password.",
  forgotEnterEmail: 'Please enter your email address',
  forgotInvalidEmail: 'Please enter a valid email address',
  forgotSendFailed: 'Failed to send reset email. Please try again.',
  forgotSuccessTitle: 'Password reset email sent!',
  forgotSuccessBody: "We've sent a password reset link to {email}. Please check your inbox and follow the instructions.",
  forgotSpamHint: "Didn't receive the email? Check your spam folder or try again.",
  forgotTryDifferentEmail: 'Try a different email',
  forgotRememberPassword: 'Remember your password?',
  forgotSendResetLink: 'Send Reset Link',
  forgotEmailPlaceholder: 'Enter your email address',

  // Maintenance landing
  maintenanceTagline: 'The future is under construction.',
  maintenanceSignIn: 'Sign in',
  maintenanceLearnMore: 'About VisiMe',
  signupEyebrow: 'Create account',
  signupTitle: 'Get your VisiMe account.',
  signupLead: 'One email, one profile. Decide in the app when and where people can find you.',
  signupBack: 'Back to sign in',
  signupSubmit: 'Create account',
  signupPasswordHint: '8–30 characters with upper, lower, and a number or special character',
  signupConsentPrefix: 'By registering you agree with our',
  signupPrivacy: 'Privacy Policy',
  signupConsentSuffix: '.',
  signupHaveAccount: 'Already have an account?',
  signupSignIn: 'Sign in',
  signupChipTitle: 'Visible near you',
  signupChipBody: 'GPS location from 1 km distance',
  signupThemeToLight: 'Switch to light mode',
  signupThemeToDark: 'Switch to dark mode',

  // VISI wizard
  visiWizardStepBasics: 'Basics',
  visiWizardStepCategory: 'Category',
  visiWizardStepContacts: 'Contacts',
  visiWizardStepMedia: 'Media',
  visiWizardStepReview: 'Review',
  visiWizardSignIn: 'Please sign in.',
  visiWizardEditTitle: 'Edit VISI',
  visiWizardCreateTitle: 'Create VISI',
  visiWizardPromoterHint: 'Promoter code will be sent with this VISI: {code}',
  visiWizardLoadCategoriesFailed: 'Could not load categories.',
  visiWizardNotFound: 'VISI not found.',
  visiWizardLoadFailed: 'Could not load VISI.',
  visiWizardDisplayName: 'Display name',
  visiWizardUsername: 'Username (without @)',
  visiWizardUsernameHint: '4–20 characters: a–z, 0–9, . _',
  visiWizardLoadingCategories: 'Loading categories…',
  visiWizardPickCategory: 'Pick the category that best matches this VISI.',
  visiWizardCategory: 'Category',
  visiWizardSubcategory: 'Subcategory',
  visiWizardSpecialization: 'Specialization (optional)',
  visiWizardNone: 'None',
  visiWizardEmail: 'Email',
  visiWizardEmailHint: 'Required contact email for this VISI.',
  visiWizardPhone: 'Mobile number',
  visiWizardPhoneHint: 'Optional. Digits without +.',
  visiWizardPhoneWhatsapp: 'WhatsApp',
  visiWizardPhoneSignal: 'Signal',
  visiWizardPhoneThreema: 'Threema',
  visiWizardSocials: 'Social media',
  visiWizardAddSocial: 'Add social channel',
  visiWizardLogoImage: 'Logo image',
  visiWizardVideo: 'Video',
  visiWizardLogoPreview: 'Logo preview',
  visiWizardReviewName: 'Name:',
  visiWizardReviewUsername: 'Username:',
  visiWizardReviewEmail: 'Email:',
  visiWizardReviewPhone: 'Phone:',
  visiWizardReviewCategory: 'Category:',
  visiWizardSaveFailed: 'Save failed.',
  visiWizardFileTooLarge: 'File too large for the server. Try a smaller image or video.',

  // VISI edit hub
  visiEditTitle: 'Edit VISI',
  visiEditViewPublic: 'View public',
  visiEditOpenWizard: 'Open full wizard',
  visiEditProfileDetails: 'Profile details',
  visiEditDangerZone: 'Danger zone',
  visiEditSectionBasics: 'Name & username',
  visiEditSectionCategory: 'Category',
  visiEditSectionBiography: 'Biography',
  visiEditSectionWebsite: 'Website',
  visiEditSectionPhones: 'Phones',
  visiEditSectionEmails: 'Emails',
  visiEditSectionAddress: 'Address',
  visiEditSectionSocials: 'Social links',
  visiEditSectionMedia: 'Logo & covers',
  visiEditSectionPayments: 'Displayed payments',
  visiEditSectionDelete: 'Delete VISI',
  visiEditPaymentsSubtitle: 'Twint / PayPal',
  visiEditSaved: 'Saved.',
  visiEditSaveFailed: 'Save failed',
  visiEditSpotifyArtistUrlOnly: 'Enter a Spotify artist URL. Albums, playlists, tracks, and shows are not supported.',
  visiEditLoadFailed: 'Could not load VISI.',
  visiEditNotFound: 'VISI not found.',
  visiEditChooseMediaFirst: 'Choose a logo or cover image first.',
  visiEditUsernameHint: 'a-z, 0-9, . _ (4–20)',
  visiEditSubSubcategory: 'Sub-subcategory',
  visiEditPhone1: 'Phone 1',
  visiEditPhone2: 'Phone 2',
  visiEditPhoneHint: 'Digits without +',
  visiEditEmail1: 'Email 1',
  visiEditEmail2: 'Email 2',
  visiEditLatitude: 'Latitude',
  visiEditLongitude: 'Longitude',
  visiEditNetwork: 'Network',
  visiEditHandleOrUrl: 'Handle or URL',
  visiEditMediaHint: 'Logo and up to 4 covers. New uploads replace the slot on save.',
  visiEditChooseLogo: 'Choose logo',
  visiEditCoverSlot: 'Cover {n}',
  visiEditPaymentsHint: 'Shown on your public VISI (not App Store billing).',
  visiEditDeleteWarning: 'This permanently deletes the VISI.',
  visiEditBiography: 'Biography',
  visiEditEdit: 'Edit',

  createVisiInstructionTitle: 'Create your VISI. Enter the name of your service.',
  createVisiNamePlaceholder: 'My VISI',
  createVisiButton: 'Create',

  // Folder detail
  folderDefaultName: 'List',
  folderInvalidList: 'Invalid list.',
  folderLoadFailed: 'Could not load this list right now.',
  folderOrganize: 'Organize',
  folderSelectVisisHint: 'Select VISIs to move or remove',
  folderSelectedCount: '{n} selected',
  folderEmptyTitle: 'No VISIs in this list',
  folderEmptyBody: 'Add businesses from feed or search to populate it.',
  noCategory: 'No category',
  folderRemoveFromListTitle: 'Remove from list',
  folderRemoveConfirm: 'Remove {n} VISI from this list?',
  folderRemoveConfirmMany: 'Remove {n} VISIs from this list?',
  removing: 'Removing…',
  remove: 'Remove',
  folderMoveToListTitle: 'Move to list',
  folderNoOtherLists: 'No other lists available.',
  folderMoveFailed: 'Could not move selected VISIs.',
  folderRemoveFailed: 'Could not remove selected VISIs.',
  folderMoveSelectedAria: 'Move selected',
  folderRemoveSelectedAria: 'Remove selected',
  folderDoneOrganizingAria: 'Done organizing',
  folderListNumber: 'List #{n}',

  // Payment methods
  settingsPaymentMethodsTitle: 'Payment methods',
  settingsPaymentAddCard: 'Add card',
  settingsPaymentNoCards: 'No saved cards',
  settingsPaymentRemoveCardAria: 'Remove card',
  settingsPaymentAddCardTitle: 'Add card',
  settingsPaymentTokenHint: 'Enter the payment processor card token (same flow as mobile backend expects).',
  settingsPaymentCardTokenLabel: 'Card token',
  settingsPaymentRemoveCardTitle: 'Remove card',
  settingsPaymentRemoveCardBody: 'Remove this card from your account?',
  settingsPaymentLoadFailed: 'Could not load payment methods.',
  settingsPaymentAddFailed: 'Could not add card.',
  settingsPaymentRemoveFailed: 'Could not remove card.',
  settingsPaymentExpires: 'Expires {month}/{year}',
  settingsPaymentDefault: 'Default',

  // Billing addresses
  settingsBillingAddressesTitle: 'Billing addresses',
  settingsBillingAddAddress: 'Add address',
  settingsBillingNoAddresses: 'No billing addresses',
  settingsBillingRemoveAddressAria: 'Remove address',
  settingsBillingNewAddressTitle: 'New billing address',
  settingsBillingRemoveAddressTitle: 'Remove address',
  settingsBillingRemoveAddressBody: 'Remove this billing address?',
  settingsBillingLoadFailed: 'Could not load billing addresses.',
  settingsBillingSaveFailed: 'Could not save address.',
  settingsBillingRemoveFailed: 'Could not remove address.',
  settingsBillingNameLabel: 'Name',
  settingsBillingStreetLabel: 'Street',
  settingsBillingCityLabel: 'City',
  settingsBillingZipLabel: 'ZIP / postal code',
  settingsBillingCountryLabel: 'Country',
  settingsBillingDefaultLabel: 'Default address',
  settingsBillingSetDefault: 'Set as default',

  // Change password
  changePasswordHint: 'Use 8–30 characters with upper, lower, and a number or special character.',
  changePasswordCurrent: 'Current password',
  changePasswordNew: 'New password',
  changePasswordConfirm: 'Confirm new password',
  changePasswordUpdate: 'Update password',
  changePasswordSuccess: 'Password updated.',
  changePasswordFailed: 'Could not change password',

  // QR code page
  qrScanHint: 'Scan to open this VISI profile',
  qrCopyLink: 'Copy link',
  qrOpenProfile: 'Open profile',
  visiEditWebsitePlaceholder: 'https://…',

  // Privacy center
  privacyTitle: 'Privacy',
  privacyIntro: 'Manage how VisiMe handles your data.',
  privacyGroupYourData: 'Your data',
  privacyDownloadData: 'Download your data',
  privacyDownloadDataSub: 'Request an export by email',
  privacyClearHistory: 'Clear search history',
  privacyClearHistorySub: 'Remove recent search queries',
  privacyGroupLegal: 'Legal',
  privacyTermsOfService: 'Terms of service',
  privacyGroupAccount: 'Account',
  privacyDeleteAccountSub: 'Open profile to delete your account',
  privacyLogoutDevice: 'Log out on this device',
  privacyDownloadSuccess: 'If your email is on file, you will receive export instructions shortly.',
  privacyDownloadFailed: 'Download request failed.',
  privacyHistoryCleared: 'Search history cleared.',
  privacyClearHistoryFailed: 'Could not clear history.',

  // Notification settings
  notificationSettingsLoadFailed: 'Could not load notification settings.',
  notificationSettingsSaveFailed: 'Could not save settings.',
  notificationPush: 'Push notifications',
  notificationSms: 'SMS',
  notificationMarketing: 'Marketing',
  notificationMarketingHint: 'Options depend on backend support for your account.',
  saveSettings: 'Save settings',

  // Advanced search
  advancedSearchTitle: 'Advanced search',
  advancedSearchSubtitle: 'Filter by keywords, category, and location',
  advancedSearchKeywords: 'Keywords',
  advancedSearchCategoryOptional: 'Category (optional)',
  advancedSearchAny: 'Any',
  advancedSearchLatitude: 'Latitude',
  advancedSearchLongitude: 'Longitude',
  advancedSearchRadiusKm: 'Radius km',
  advancedSearchSort: 'Sort',
  advancedSearchSortDistance: 'Distance',
  advancedSearchSortName: 'Name',
  advancedSearchSortRecent: 'Recent',
  advancedSearchRun: 'Search',
  advancedSearchFailed: 'Search failed',
  advancedSearchEmptyTitle: 'No results',
  advancedSearchEmptyBody: 'Try different filters or keywords.',

  // Report / request
  reportRequestTitle: 'Request',
  reportProblemTitle: 'Report a problem',
  reportRequestSubtitle: 'Tell us what you would like to see improved or added.',
  reportProblemSubtitle: 'Describe what went wrong. Your message is sent to VisiMe support.',
  supportCategory: 'Category',
  reportPlaceholderRequest: 'Your request…',
  reportPlaceholderProblem: 'What happened?',
  sending: 'Sending…',
  send: 'Send',
  sentDefault: 'Sent.',
  supportLoadCategoriesFailed: 'Could not load categories',
  supportSendFailed: 'Send failed',

  // Notifications list
  notificationsLoadFailed: 'Failed to load',
  notificationFallback: 'Update',

  // Location settings
  locationSettingsTitle: 'Location',
  locationSettingsIntro:
    'Choose how VisiMe measures distance on web — same idea as the mobile location picker. Network location uses your public IP (ISP / city level) when you do not share GPS.',
  locationModeGps: 'Use device location (GPS)',
  locationModeIp: 'Use approximate network location (ISP / IP)',
  locationModeFixed: 'Use a fixed address',
  locationUpdating: 'Updating…',
  locationGpsUnavailable: 'Device location unavailable — Home will use network approx or Zürich.',
  locationUsingGps: 'Using device GPS when available.',
  locationIpFailed: 'Could not resolve network location. Try again or pick a fixed address.',
  locationUsingIp: 'Using approximate network (ISP) location — city-level only.',
  locationPickFixed: 'Pick a city or address below.',
  locationFixedSaved: 'Fixed location saved for distance sorting.',
  locationZurichDefault: 'Using Bahnhofstrasse, Zürich (same default as the app).',
  locationSearchLabel: 'Search city or address',
  locationSearchPlaceholder: 'e.g. Zürich, Bahnhofstrasse',
  locationUseZurich: 'Use Bahnhofstrasse, Zürich',
  locationSearching: 'Searching…',
  locationActiveForHome: 'Active for Home distance: {label}',
  locationSaved: 'Saved: {address}',
  locationCurrentAddress: 'Current location',

  // Nearby map (iOS vcNearbyFixedMap parity)
  mapLocating: 'Locating…',
  mapAuthRequired: 'Sign in to see nearby businesses on the map.',
  mapFixedEmpty: 'No fixed-address businesses within 10 km.',
  mapFixedCountLocal: '{count} fixed-address businesses within 10 km',
  mapLoadFailed: 'Could not load the map. Try again.',
  settingsNearbyMap: 'Nearby map',
  settingsNearbyMapSub: 'Fixed-address businesses within 10 km',

  // Maps settings
  mapsSettingsIntro: 'Preferred map app for opening addresses (stored on this device).',
  mapsApple: 'Apple Maps',
  mapsGoogle: 'Google Maps',

  // Feed tabs (legacy)
  feedTabVisi: 'VISI Feed',
  feedTabNotification: 'Notifications',

  profileLoading: 'Loading…',
  brandName: 'VisiMe',
  languageAria: 'Language',
  settingsAria: 'Settings',
  loadingFeedAria: 'Loading feed',
  primaryNavAria: 'Primary',
  visiShellTitle: 'VISI',
  visiEditPaypalLabel: 'PayPal',
  socialFacebookAria: 'Facebook',
  socialInstagramAria: 'Instagram',
  socialXAria: 'X',
  headerNotificationsAria: 'Notifications',
  searching: 'Searching…',
  registerConfirmPassword: 'Confirm password',
  discoverNoBusinessesTitle: 'No businesses',
  discoverNoBusinessesBody: 'Try refreshing to load new suggestions',
  discoverRefresh: 'Refresh',
  discoverRefreshAria: 'Refresh discover feed',
  discoverSectionLabel: 'Discover',
  notificationsUpdatesTitle: 'Updates',
  notificationsEmptyListBody: 'Favorites in your lists will surface news here.',
  mapsDefaultMaps: 'Default maps',
  folderDragReorderAria: 'Drag to reorder',
  folderOrganizeDragHint: 'Drag to reorder, or select VISIs to move or remove',
  folderSavingOrder: 'Saving order…',
  visiEditTwintLabel: 'Twint',
  advancedSearchRunAria: 'Run advanced search',
  goBack: 'Go back',
  landingMenuTitle: 'Menu',
  landingMenuOpenAria: 'Menu',
  landingCloseAria: 'Close',
  landingBillingToggleAria: 'Billing period',
  landingGetStartedEyebrow: 'Get started',
  landingFooterNavigationHeading: 'Navigation',
  landingFooterUsefulLinksHeading: 'Useful links',
  landingPlanVisiSingle: 'VISI Single',
  landingPlanVisiDuo: 'VISI Duo',
  landingPlanVisiPromoter: 'VISI Promoter',
  profileDemoName: 'Sample profile',
  profileDemoTitle: 'Sample professional',
  profileDemoDescription: 'Placeholder profile for development preview.',

  // Waiting list
  waitlistMetaTitle: 'VisiMe waiting list',
  waitlistMetaDescription:
    'Join the VisiMe waiting list with your email and share your invite link to climb the ranking.',
  waitlistEyebrow: 'Early access',
  waitlistTitle: 'Join the waiting list',
  waitlistLead:
    'Leave your email — we only store it for the list and never send mail. Invite friends to move up.',
  waitlistBackHome: 'Back to home',
  waitlistEmailLabel: 'Email address',
  waitlistEmailPlaceholder: 'name@example.com',
  waitlistSubmit: 'Join the list',
  waitlistSubmitting: 'Saving…',
  waitlistInvalidEmail: 'Please enter a valid email address.',
  waitlistConnectionError: 'Connection failed. Please try again.',
  waitlistGenericError: 'Could not join the waiting list. Please try again.',
  waitlistRestoring: 'Restoring your place…',
  waitlistInviteActive: 'Invite active — code {code}',
  waitlistAlreadyKicker: 'You are already on the list',
  waitlistWelcomeKicker: 'Welcome to the list',
  waitlistBucketTop1: 'Top 1%',
  waitlistBucketTop10: 'Top 10%',
  waitlistBucketTop50: 'Top 50%',
  waitlistBucketInList: 'On the waiting list',
  waitlistHintTop1: 'You are in the first percent — strong start.',
  waitlistHintTop10: 'You are in the top 10%. Every invite helps you climb.',
  waitlistHintTop50: 'You are in the upper half. Share your link to rise further.',
  waitlistHintInList: 'You are on the list. Invite friends to improve your place.',
  waitlistReferralCountOne: '{n} successful referral',
  waitlistReferralCountMany: '{n} successful referrals',
  waitlistShareTitle: 'Your invite link',
  waitlistShareLead: 'Friends who join with your link move you up the ranking.',
  waitlistShareInputAria: 'Invite link',
  waitlistCopy: 'Copy',
  waitlistShare: 'Share link',
  waitlistCodePrefix: 'Code:',
  waitlistCopied: 'Link copied — share it with friends.',
  waitlistCopyFailed: 'Could not copy the link.',
  waitlistShareNativeTitle: 'VisiMe waiting list',
  waitlistShareNativeText: 'Join the VisiMe waiting list with my invite:',
  waitlistHowTitle: 'How it works',
  waitlistHowStep1: 'Join with your email',
  waitlistHowStep2: 'Share your personal invite link',
  waitlistHowStep3: 'Climb when friends sign up',
  waitlistAlreadyAccount: 'Already have an account?',
  waitlistSignIn: 'Sign in',
  waitlistCtaShort: 'Waiting list',
  waitlistCtaLong: 'Join the waiting list',
  waitlistThemeLightAria: 'Switch to light mode',
  waitlistThemeDarkAria: 'Switch to dark mode',
  marketingNavApp: 'The app',
  marketingNavVisi: 'VISI',
  marketingNavMe: 'ME',
  marketingNavPricing: 'Pricing',
  marketingNavWaitlist: 'Waiting list',
  marketingNavSupport: 'Support',
};

const de: typeof en = {
  cancel: 'Abbrechen',
  continue: 'Weiter',
  back: 'Zurück',
  done: 'Fertig',
  okay: 'Okay',
  delete: 'Löschen',
  loading: 'Laden…',
  website: 'Website',
  email: 'E-Mail',
  phone: 'Telefon',
  password: 'Passwort',
  openInMaps: 'In Karten öffnen',

  feedFilter: 'Feed-Filter',
  favoritesOnly: 'Nur Favoriten anzeigen (gespeicherte Profile)',
  locationFilter: 'Standorttyp',
  filterAll: 'Alle',
  filterFixedAddress: 'Fester Standort',
  filterGpsBased: 'Live-Standort',
  filterAllHint: 'Feste und Live-Standorte',
  filterFixedHint: 'Profile mit festem Standort',
  filterGpsHint: 'Profile mit Live-/GPS-Standort',

  contactSocial: 'Kontakt & Social',
  socialsSection: 'Socials',
  contactSection: 'Kontakt',
  noContacts: 'Keine Kontaktdaten',
  playVideo: 'Video abspielen',
  selectAction: 'Aktion wählen',
  directCall: 'Anrufen',
  sendSms: 'SMS senden',
  openEmail: 'E-Mail öffnen',
  openWebsite: 'Website öffnen',
  openLink: 'Link öffnen',
  copyValue: 'Kopieren',
  copied: 'Kopiert',
  closeAction: 'Schliessen',

  deleteAccount: 'Konto löschen',
  deleteAccountWarnTitle: 'Konto wirklich löschen?',
  deleteAccountWarnBody:
    'Dein ME-Konto und deine Daten werden dauerhaft entfernt. Laufende VISI-Abos werden über den App Store oder Google Play verwaltet und nicht automatisch gekündigt.',
  deleteAccountReasonTitle: 'Grund auswählen',
  deleteAccountReasonHelp:
    'Wir werden ständig besser. Bitte hilf uns, indem du einen Grund auswählst.',
  deleteAccountReasonLabel: 'Grund',
  deleteAccountMessageLabel: 'Optionale Nachricht',
  deleteAccountConfirmTitle: 'Löschung bestätigen',
  deleteAccountConfirmBody: 'Dies kann nicht rückgängig gemacht werden. Dein Konto wird sofort entfernt.',
  deleteAccountNeedReason: 'Bitte wähle einen Grund aus',
  deleteAccountFailed: 'Konto konnte nicht gelöscht werden.',
  deleteAccountFarewellTitle: 'Auf Wiedersehen',
  next: 'Weiter',

  subscription: 'Abonnement',
  subscriptionInfo:
    'Käufe erfolgen in den iOS-/Android-Apps. Diese Seite zeigt den Serverstatus; die Abrechnung verwaltest du im Store.',
  subscriptionStatus: 'Status',
  subscriptionActive: 'Aktiv',
  subscriptionCanceled: 'Gekündigt',
  subscriptionFree: 'Gratis',
  subscriptionNoPlan: 'Kein Abonnement',
  subscriptionPlan: 'Tarif',
  subscriptionFreePlan: 'Gratis-Tarif',
  subscriptionUpgradeHint: 'Upgrade in der App, um dein VISI-Profil zu veröffentlichen',
  subscriptionSlots: 'Bis zu {n} sichtbare VISI-Profile',
  subscriptionBenefits: 'Abo-Vorteile',
  subscriptionStart: 'Beginn',
  subscriptionEnd: 'Ende',
  subscriptionProduct: 'Produkt',
  linkedBusinesses: 'Verknüpfte Unternehmen',
  promoterCodes: 'Promoter-Codes',
  manageAppStore: 'App-Store-Abos',
  managePlayStore: 'Google-Play-Abos',
  subscriptionRenews: 'Verlängert sich',
  subscriptionPrice: 'Preis',
  subscriptionPlanDetail: '{slots} VISI + {promoters} Promoter',
  subscriptionMonth: 'Monat',
  subscriptionYear: 'Jahr',
  privacyPolicyTitle: 'Datenschutzerklärung',
  privacyPolicyAccept: 'Akzeptieren und fortfahren',
  privacyPolicyScrollHint: 'Scrolle bis zum Ende der Richtlinie, um Akzeptieren zu aktivieren.',
  none: '—',

  language: 'Sprache',
  languageHint: 'Die UI-Sprache wird lokal gespeichert und an API-Anfragen übergeben.',

  appearance: 'Darstellung',
  appearanceHint: 'Hell oder dunkel wählen, oder der Geräteeinstellung folgen. Nur auf diesem Gerät gespeichert.',
  appearanceSystem: 'System',
  appearanceLight: 'Hell',
  appearanceDark: 'Dunkel',

  navHome: 'Start',
  navSearch: 'Suche',
  navLists: 'Listen',
  navProfile: 'Profil',
  navSettings: 'Einstellungen',
  navMap: 'Karten',
  navCreate: 'Erstellen',
  navGuest: 'Gast',
  navAccount: 'Konto',

  promoTitle: 'Sichtbar, wo du bist.',
  promoBody: 'Erstelle dein VISI Profil und verbinde dich mit Menschen in deiner Umgebung.',
  promoCta: 'Mehr erfahren',

  homeComposer: 'Was beschäftigt dich?',
  homeTabForYou: 'Für dich',
  homeTabNotifications: 'Mitteilungen',
  homeFeedFilters: 'Feed-Filter',
  homeFeedEmptyTitle: 'Keine VISIs in deinem Feed',
  homeFeedEmptyBody: 'Tippe auf +, um Kategorien zu wählen, oder suche nach Menschen und Orten.',
  homeUpdatesLoading: 'Neuigkeiten werden geladen…',
  homeUpdatesEmptyTitle: 'Noch keine Neuigkeiten',
  homeUpdatesEmptyBody: 'Favoriten und gespeicherte Listen zeigen hier ihre Aktivitäten.',
  homeUpdatesFailed: 'Neuigkeiten konnten nicht geladen werden',
  homeAddCategoryTitle: 'Interessenkategorie hinzufügen',
  homeAddCategoryLabel: 'Kategorie',
  homeAddCategoryEmpty: 'Alle verfügbaren Kategorien sind bereits in deiner Liste, oder die Daten werden noch geladen.',
  homeAddCategoryFailed: 'Kategorie konnte nicht hinzugefügt werden',
  homeAddCategoryLoadFailed: 'Kategorien konnten nicht geladen werden.',
  homeManageCategoriesTitle: 'Deine Kategorien',
  homeManageCategoriesHint: 'Tippen zum Auswählen oder Abwählen. Fertig speichert deine Start-Interessen.',
  homeManageCategoriesSearch: 'Kategorien suchen',
  homeManageCategoriesEmpty: 'Keine Kategorien passen zu deiner Suche.',
  homeManageCategoriesFailed: 'Kategorien konnten nicht gespeichert werden',
  homeManageCategoriesAria: 'Kategorien verwalten',
  add: 'Hinzufügen',
  adding: 'Wird hinzugefügt…',
  saving: 'Wird gespeichert…',
  homeAiResultsFor: 'Ergebnisse für: „{q}“',
  homeAiAsking: 'KI-Suche läuft für: „{q}“…',
  homeAiNoBusinesses: 'Keine Einträge zum Durchsuchen. Bitte wähle zuerst eine Kategorie.',
  homeAiFailed: 'Die KI-Suche ist fehlgeschlagen. Bitte versuche es erneut.',
  homeAiNoMatch: 'Die KI hat keine passenden Einträge gefunden für: „{q}“',

  companionSearch: 'VisiMe durchsuchen',
  companionUpNext: 'Als Nächstes',
  companionSeeAll: 'Alle ansehen',
  companionUpNextEmpty: 'Folge Start-Kategorien — Als Nächstes zeigt top gespeicherte VISIs daraus.',
  companionLists: 'Deine Listen',
  companionListsEmpty: 'Speichere VISIs in Listen, um sie später wiederzufinden.',
  companionOpenLists: 'Listen öffnen',
  companionVisis: 'Deine VISIs',
  companionNoVisis: 'Noch keine VISI Profile',
  companionVisiStats: '{total} Profile · {visible} sichtbar',
  companionAddNew: 'Neu anlegen',
  companionHelpLegal: 'Hilfe & Rechtliches',
  companionHelpCenter: 'Hilfe & Support',
  companionReport: 'Problem melden',
  companionPrivacy: 'Datenschutz und Sicherheit',

  visiInfoNavTitle: 'Was ist VISI?',
  visiInfoHeroKicker: 'VisiMe erklärt',
  visiInfoHeroTitle: 'Ein VISI macht dich sichtbar, wo du bist.',
  visiInfoHeroBody:
    'Dein ME-Konto ist dein privates Konto. Ein VISI ist dein öffentliches Profil: Es zeigt, was du anbietest, wo du bist und wie man dich erreicht — an einer festen Adresse oder mit einem Live-Standort.',
  visiInfoWhatTitle: 'Was ein VISI ist',
  visiInfoWhatBody:
    'Ein VISI ist ein öffentliches Profil für eine Person, ein Unternehmen, einen Verein oder ein Projekt. Es enthält Name, Kategorien, Beschreibung, Bilder, Kontaktdaten und Standort — und erscheint im Feed von Menschen in der Nähe, die deinen Kategorien folgen.',
  visiInfoMeVsVisiTitle: 'ME-Konto und VISI Profil',
  visiInfoMeVsVisiBody:
    'Das ME-Konto ist kostenlos und privat: Du stöberst, speicherst Listen und folgst Kategorien. Ein VISI Profil ist veröffentlicht und für andere auffindbar. Ein ME-Konto kann je nach Abo mehrere VISI Profile verwalten.',
  visiInfoLocationTitle: 'Feste Adresse oder Live-Standort',
  visiInfoLocationBody:
    'Ein VISI mit fester Adresse bleibt immer an seinem Ort — Laden, Büro, Praxis. Ein VISI mit Live-Standort bewegt sich mit dir und passt zu Märkten, Foodtrucks, Handwerk und Veranstaltungen. Du wählst den Modus je Profil.',
  visiInfoDiscoveryTitle: 'So finden dich andere',
  visiInfoDiscoveryBody:
    'Nutzer wählen ihre Kategorien und sehen passende VISIs in der Nähe, sortiert nach Entfernung. Sie können dich in einer Liste speichern, als Favorit markieren und deine Kontaktdaten, Website oder Karte mit einem Tipp öffnen.',
  visiInfoStepsTitle: 'In drei Schritten zum VISI',
  visiInfoStep1Title: 'Kategorie wählen',
  visiInfoStep1Body: 'Kategorie und Unterkategorien entscheiden, in wessen Feed dein VISI erscheint.',
  visiInfoStep2Title: 'Beschreiben und bebildern',
  visiInfoStep2Body: 'Name, Beschreibung, Logo, Titelbilder und Kontaktdaten vervollständigen das Profil.',
  visiInfoStep3Title: 'Standort festlegen',
  visiInfoStep3Body: 'Wähle eine feste Adresse oder einen Live-Standort und veröffentliche das Profil.',
  visiInfoSubscriptionTitle: 'Abo und Sichtbarkeit',
  visiInfoSubscriptionBody:
    'Für die Veröffentlichung eines VISI ist ein aktives Abo nötig. Käufe laufen über den App Store oder Google Play; diese Website zeigt den aktuellen Status deines Kontos.',
  visiInfoCtaTitle: 'Bereit für dein eigenes VISI?',
  visiInfoCtaBody: 'Lege jetzt dein Profil an — alle Angaben lassen sich später bearbeiten.',
  visiInfoCtaButton: 'VISI erstellen',

  save: 'Speichern',
  clear: 'Löschen',
  close: 'Schliessen',
  rename: 'Umbenennen',
  submit: 'Senden',
  share: 'Teilen',
  report: 'Melden',
  saved: 'Gespeichert',
  saveToList: 'In Liste speichern',
  addToList: 'Zur Liste hinzufügen',
  manageLists: 'Listen verwalten',
  folderNoListsYet: 'Noch keine Listen. Erstelle eine unter Listen.',
  addedToList: 'Hinzugefügt zu {name}',
  couldNotAdd: 'Konnte nicht hinzufügen',
  couldNotLoadLists: 'Listen konnten nicht geladen werden',
  listItemsCount: '{n} Einträge',
  reported: 'Gemeldet.',
  reportFailed: 'Meldung fehlgeschlagen',
  reportVisi: 'VISI melden',
  businessNotFound: 'Eintrag nicht gefunden',
  failedLoadBusiness: 'Eintrag konnte nicht geladen werden',
  businessIdRequired: 'Eintrags-ID ist erforderlich',
  tabRecommended: 'Empfohlen',
  tabSamePerson: 'Gleiche Person',
  qrCode: 'QR-Code',
  shareProfileAria: 'Profil teilen',
  qrCodeAria: 'QR-Code',
  reportAria: 'Melden',
  languageEnglish: 'English',
  languageGerman: 'Deutsch',

  settingsGroupAccount: 'Konto',
  settingsGroupBilling: 'Abrechnung',
  settingsGroupPreferences: 'Einstellungen',
  settingsGroupDataPrivacy: 'Daten & Datenschutz',
  settingsGroupSupport: 'Support',
  settingsGroupLegal: 'Rechtliches',
  settingsConfirmEmail: 'E-Mail bestätigen',
  settingsConfirmEmailSub: 'E-Mail-Adresse verifizieren',
  settingsLocation: 'Standort',
  settingsLocationSub: 'GPS, Netzwerk-Näherung oder fester Standort',
  settingsMaps: 'Karten',
  settingsMapsSub: 'Bevorzugter Kartenanbieter',
  settingsChangePassword: 'Passwort ändern',
  settingsChangePasswordSub: 'Anmeldepasswort aktualisieren',
  settingsSubscriptionSub: 'Verwalten über App Store / Play',
  settingsNotifications: 'Mitteilungen',
  settingsNotificationsSub: 'Push, E-Mail, SMS, Marketing',
  settingsSearchHistory: 'Suchverlauf',
  settingsSearchHistorySub: 'Letzte Suchen löschen',
  settingsDownloadData: 'Daten herunterladen',
  settingsDownloadDataSub: 'Export per E-Mail anfordern',
  settingsPrivacySecurity: 'Datenschutz und Sicherheit',
  settingsPrivacySecuritySub: 'Richtlinien und Kontosteuerung',
  settingsRequest: 'Anfrage',
  settingsPrivacyPolicy: 'Datenschutzerklärung',
  settingsTermsOfService: 'Nutzungsbedingungen',
  settingsLogout: 'Abmelden',
  settingsLogoutTitle: 'Abmelden?',
  settingsLogoutBody: 'Du kannst dich jederzeit wieder mit deiner E-Mail anmelden.',
  settingsClearHistoryTitle: 'Suchverlauf löschen?',
  settingsClearHistoryBody: 'Damit werden deine letzten Suchanfragen in diesem Konto entfernt.',
  settingsClearHistory: 'Löschen',
  settingsNotSignedIn: 'Nicht angemeldet.',
  settingsClearHistoryFailed: 'Verlauf konnte nicht gelöscht werden.',
  settingsDownloadFailed: 'Anfrage fehlgeschlagen. Bitte später erneut versuchen.',
  settingsDownloadSuccess: 'Falls deine E-Mail hinterlegt ist, erhältst du in Kürze Export-Anweisungen.',

  bookmarksListCountOne: '{n} Liste',
  bookmarksListCountMany: '{n} Listen',
  bookmarksCreateListAria: 'Liste erstellen',
  bookmarksSortNameAz: 'Name (A-Z)',
  bookmarksSortDateCreated: 'Erstellungsdatum',
  bookmarksSortBusinessCount: 'Anzahl Einträge',
  bookmarksSortLabelAz: 'A-Z',
  bookmarksSortLabelDate: 'Datum',
  bookmarksSortLabelCount: 'Anzahl',
  bookmarksNoListsTitle: 'Noch keine Listen',
  bookmarksNoListsBody: 'Erstelle eine Liste, um deine Lieblings-VISIs zu organisieren',
  bookmarksCreateList: 'Liste erstellen',
  bookmarksListOptionsAria: 'Listenoptionen',
  bookmarksCreateNewList: 'Neue Liste erstellen',
  bookmarksListName: 'Listenname',
  bookmarksListNamePlaceholder: 'Freunde, Arbeit, Favoriten',
  bookmarksRenameList: 'Liste umbenennen',
  bookmarksDeleteList: 'Liste löschen',
  bookmarksDeleteListBody: 'Diese Liste wirklich löschen? Die VISIs darin werden nicht gelöscht.',
  visiCountOne: '{n} VISI',
  visiCountMany: '{n} VISIs',

  searchPlaceholder: 'VISI, Kategorien suchen…',
  searchAdvanced: 'Erweitert',
  searchAdvancedAria: 'Erweiterte Suche',
  searchTabVisi: 'VISI',
  searchTabCategories: 'Kategorien',
  searchRecent: 'Zuletzt',
  searchClearAll: 'Alle löschen',
  searchEmptyTitle: 'VISIs suchen',
  searchEmptyBody: 'Tippe, um Unternehmen und Kategorien zu finden',
  searchNoVisisFor: 'Keine VISIs gefunden für „{q}“',
  searchSuggested: 'Vorschläge',
  searchNoCategoriesFor: 'Keine Kategorien gefunden für „{q}“',
  searchNoCategoriesAvailable: 'Keine Kategorien verfügbar',

  myProfileTitle: 'Mein Profil',
  myProfileSignInTitle: 'Melde dich an, um dein Profil zu sehen',
  myProfileLogin: 'Anmelden',
  meAccount: 'ME-KONTO',
  myProfileAccountHint: 'Dein persönliches Konto. Details jederzeit bearbeiten — getrennt von deinen öffentlichen VISI Profilen.',
  myProfileEditAccountAria: 'Konto bearbeiten',
  myProfileSettingsAria: 'Einstellungen',
  myProfileAccountFallback: 'Konto',
  visiProfilesSection: 'VISI PROFILE',
  myProfileNoVisisYet: 'Noch keine VISI Profile',
  myProfileVisiCountOne: '{total} Profil · {visible} sichtbar',
  myProfileVisiCountMany: '{total} Profile · {visible} sichtbar',
  myProfileMakeFirstVisible: 'Erstes VISI sichtbar machen',
  myProfileNoneVisibleWarning: 'Keines deiner VISIs ist sichtbar. Schalte Sichtbar ein, damit andere dich finden.',
  myProfileWithPromoterCode: 'Mit Promoter-Code',
  myProfileLoadVisisFailed: 'Deine VISI Profile konnten nicht geladen werden.',
  myProfileNoPublicVisisTitle: 'Noch keine öffentlichen VISIs',
  myProfileNoPublicVisisBody: 'Lege ein VISI Profil an, damit andere dich finden.',
  myProfileVisiColumn: 'Visi',
  myProfileVisibleColumn: 'Sichtbar',
  myProfileEditVisiAria: 'VISI bearbeiten',
  myProfileQrAria: 'QR-Code',
  myProfileHideTestProfiles: 'Testprofile ausblenden',
  myProfileShowTestProfiles: '{n} Testprofile anzeigen',
  myProfileEditAccount: 'Konto bearbeiten',
  myProfileChangePhoto: 'Profilbild ändern',
  myProfileFirstName: 'Vorname*',
  myProfileLastName: 'Nachname',
  myProfileBirthday: 'Geburtstag',
  myProfileFirstNameMin: 'Der Vorname muss mindestens 2 Zeichen haben.',
  myProfileSaveFailed: 'Profil konnte nicht gespeichert werden.',
  myProfileMaxVisibleReached: 'Du hast die maximale Anzahl gleichzeitig sichtbarer VISI Profile erreicht.',
  myProfileVisibilityFailed: 'Sichtbarkeit konnte nicht aktualisiert werden.',
  myProfilePromoterTitle: 'Promoter-Code eingeben',
  myProfilePromoterHint: 'Nutze einen Promoter-Code für besondere Onboarding-Vorteile.',
  myProfilePromoterCode: 'Promoter-Code',
  myProfilePromoterInvalid: 'Ungültiger Promoter-Code.',
  myProfilePromoterVerifyFailed: 'Promoter-Code konnte nicht verifiziert werden.',

  headerAskProposals: 'Frage zu Vorschlägen…',
  headerSearchAria: 'Suche',

  loginWelcome: 'Willkommen bei VisiMe',
  loginOrRegisterTitle: 'Einloggen oder registrieren',
  loginSignInTitle: 'Einloggen',
  loginSubtitle: 'Melde dich an, um lokale Angebote zu nutzen',
  loginContinue: 'Weiter',
  loginEmailLabel: 'E-Mail-Adresse',
  loginEditEmail: 'Bearbeiten',
  loginEmailCheckFailed: 'E-Mail konnte nicht geprüft werden. Bitte versuche es erneut.',
  loginTermsHintBeforeTerms: 'Wenn du ein Konto erstellst, stimmst du unseren',
  loginTermsLink: 'Nutzungsbedingungen',
  loginTermsHintMiddle: 'zu. Du erfährst in unserer',
  loginPrivacyLink: 'Datenschutzerklärung',
  loginTermsHintAfterPrivacy: ', wie wir deine Daten verarbeiten.',
  loginImprint: 'Impressum',
  loginPrivacyPolicy: 'Datenschutzerklärung',
  loginShowPassword: 'Passwort anzeigen',
  loginHidePassword: 'Passwort verbergen',
  loginFillAllFields: 'Bitte fülle alle Felder aus',
  loginInvalidEmail: 'Bitte gib eine gültige E-Mail-Adresse ein',
  loginFailed: 'Anmeldung fehlgeschlagen. Bitte versuche es erneut.',
  loginForgotPassword: 'Passwort vergessen?',
  loginSignIn: 'Anmelden',
  registerTitle: 'Registrieren',
  registerSubmit: 'Registrieren',
  registerFirstName: 'Vorname',
  registerLastName: 'Nachname',
  registerBirthday: 'Geburtsdatum',
  registerBirthdayPlaceholder: 'TT.MM.JJJJ',
  registerBirthdayHint: 'Du musst mindestens 16 Jahre alt sein.',
  registerBirthdayInvalid: 'Bitte gib ein gültiges Geburtsdatum ein (TT.MM.JJJJ).',
  registerPasswordHint: 'Dein Passwort muss mindestens 8 Zeichen lang sein.',
  registerBirthdayStepTitle: 'Geburtsdatum',
  registerPasswordRules:
    'Das Passwort muss 8–40 Zeichen lang sein und Gross-, Kleinbuchstaben sowie eine Zahl oder ein Symbol enthalten.',
  registerFailed: 'Registrierung fehlgeschlagen. Bitte versuche es erneut.',
  loginOrContinueWith: 'oder',
  loginContinueGoogle: 'Weiter mit Google',
  loginContinueApple: 'Weiter mit Apple',
  socialLoginFailed: 'Social-Anmeldung fehlgeschlagen. Bitte versuche es erneut.',
  socialLoginEmailRequired: 'Google hat keine E-Mail für dieses Konto bereitgestellt.',
  socialAppleNotConfigured: 'Apple-Anmeldung ist in dieser Umgebung nicht konfiguriert.',
  socialBirthdayTitle: 'Dein Geburtstag',
  socialBirthdaySubtitle: 'Du musst mindestens 16 Jahre alt sein, um VisiMe zu nutzen.',
  socialBirthdayLabel: 'Geburtstag',
  socialBirthdayContinue: 'Weiter',
  socialBirthdayRequired: 'Bitte gib deinen Geburtstag ein.',
  socialBirthdayFailed: 'Geburtstag konnte nicht gespeichert werden. Bitte versuche es erneut.',
  forgotBackToLogin: 'Zurück zur Anmeldung',
  forgotTitle: 'Passwort zurücksetzen',
  forgotSubtitle: 'Gib deine E-Mail-Adresse ein — wir senden dir einen Link zum Zurücksetzen.',
  forgotEnterEmail: 'Bitte gib deine E-Mail-Adresse ein',
  forgotInvalidEmail: 'Bitte gib eine gültige E-Mail-Adresse ein',
  forgotSendFailed: 'Reset-E-Mail konnte nicht gesendet werden. Bitte versuche es erneut.',
  forgotSuccessTitle: 'Reset-E-Mail gesendet!',
  forgotSuccessBody: 'Wir haben einen Link zum Zurücksetzen an {email} gesendet. Bitte prüfe dein Postfach und folge den Anweisungen.',
  forgotSpamHint: 'Keine E-Mail erhalten? Prüfe den Spam-Ordner oder versuche es erneut.',
  forgotTryDifferentEmail: 'Andere E-Mail versuchen',
  forgotRememberPassword: 'Passwort wieder eingefallen?',
  forgotSendResetLink: 'Reset-Link senden',
  forgotEmailPlaceholder: 'E-Mail-Adresse eingeben',

  maintenanceTagline: 'Die Zukunft wird gerade gebaut.',
  maintenanceSignIn: 'Anmelden',
  maintenanceLearnMore: 'Mehr über VisiMe',
  signupEyebrow: 'Konto erstellen',
  signupTitle: 'Dein VisiMe Konto.',
  signupLead: 'Eine E-Mail, ein Profil. In der App entscheidest du, wann und wo man dich findet.',
  signupBack: 'Zurück zur Anmeldung',
  signupSubmit: 'Konto erstellen',
  signupPasswordHint: '8–30 Zeichen mit Gross-, Kleinbuchstaben und Zahl oder Sonderzeichen',
  signupConsentPrefix: 'Mit der Registrierung stimmst du unserer',
  signupPrivacy: 'Datenschutzerklärung',
  signupConsentSuffix: ' zu.',
  signupHaveAccount: 'Bereits ein Konto?',
  signupSignIn: 'Anmelden',
  signupChipTitle: 'Sichtbar in deiner Nähe',
  signupChipBody: 'GPS-Standort ab 1 km Distanz',
  signupThemeToLight: 'Hellen Modus aktivieren',
  signupThemeToDark: 'Dunklen Modus aktivieren',

  visiWizardStepBasics: 'Grundlagen',
  visiWizardStepCategory: 'Kategorie',
  visiWizardStepContacts: 'Kontakte',
  visiWizardStepMedia: 'Medien',
  visiWizardStepReview: 'Prüfen',
  visiWizardSignIn: 'Bitte melde dich an.',
  visiWizardEditTitle: 'VISI bearbeiten',
  visiWizardCreateTitle: 'VISI erstellen',
  visiWizardPromoterHint: 'Promoter-Code wird mit diesem VISI gesendet: {code}',
  visiWizardLoadCategoriesFailed: 'Kategorien konnten nicht geladen werden.',
  visiWizardNotFound: 'VISI nicht gefunden.',
  visiWizardLoadFailed: 'VISI konnte nicht geladen werden.',
  visiWizardDisplayName: 'Anzeigename',
  visiWizardUsername: 'Benutzername (ohne @)',
  visiWizardUsernameHint: '4–20 Zeichen: a–z, 0–9, . _',
  visiWizardLoadingCategories: 'Kategorien werden geladen…',
  visiWizardPickCategory: 'Wähle die Kategorie, die am besten zu diesem VISI passt.',
  visiWizardCategory: 'Kategorie',
  visiWizardSubcategory: 'Unterkategorie',
  visiWizardSpecialization: 'Spezialisierung (optional)',
  visiWizardNone: 'Keine',
  visiWizardEmail: 'E-Mail',
  visiWizardEmailHint: 'Pflichtfeld – Kontakt-E-Mail für dieses VISI.',
  visiWizardPhone: 'Handynummer',
  visiWizardPhoneHint: 'Optional. Ziffern ohne +.',
  visiWizardPhoneWhatsapp: 'WhatsApp',
  visiWizardPhoneSignal: 'Signal',
  visiWizardPhoneThreema: 'Threema',
  visiWizardSocials: 'Social Media',
  visiWizardAddSocial: 'Social-Kanal hinzufügen',
  visiWizardLogoImage: 'Logo-Bild',
  visiWizardVideo: 'Video',
  visiWizardLogoPreview: 'Logo-Vorschau',
  visiWizardReviewName: 'Name:',
  visiWizardReviewUsername: 'Benutzername:',
  visiWizardReviewEmail: 'E-Mail:',
  visiWizardReviewPhone: 'Telefon:',
  visiWizardReviewCategory: 'Kategorie:',
  visiWizardSaveFailed: 'Speichern fehlgeschlagen.',
  visiWizardFileTooLarge: 'Datei zu gross für den Server. Versuche ein kleineres Bild oder Video.',

  visiEditTitle: 'VISI bearbeiten',
  visiEditViewPublic: 'Öffentlich ansehen',
  visiEditOpenWizard: 'Vollständigen Assistenten öffnen',
  visiEditProfileDetails: 'Profildetails',
  visiEditDangerZone: 'Gefahrenzone',
  visiEditSectionBasics: 'Name & Benutzername',
  visiEditSectionCategory: 'Kategorie',
  visiEditSectionBiography: 'Biografie',
  visiEditSectionWebsite: 'Website',
  visiEditSectionPhones: 'Telefon',
  visiEditSectionEmails: 'E-Mails',
  visiEditSectionAddress: 'Adresse',
  visiEditSectionSocials: 'Social Links',
  visiEditSectionMedia: 'Logo & Titelbilder',
  visiEditSectionPayments: 'Angezeigte Zahlungen',
  visiEditSectionDelete: 'VISI löschen',
  visiEditPaymentsSubtitle: 'Twint / PayPal',
  visiEditSaved: 'Gespeichert.',
  visiEditSaveFailed: 'Speichern fehlgeschlagen',
  visiEditSpotifyArtistUrlOnly: 'Gib eine Spotify-Künstler-URL ein. Alben, Playlists, Titel und Shows werden nicht unterstützt.',
  visiEditLoadFailed: 'VISI konnte nicht geladen werden.',
  visiEditNotFound: 'VISI nicht gefunden.',
  visiEditChooseMediaFirst: 'Wähle zuerst ein Logo oder Titelbild.',
  visiEditUsernameHint: 'a-z, 0-9, . _ (4–20)',
  visiEditSubSubcategory: 'Unter-Unterkategorie',
  visiEditPhone1: 'Telefon 1',
  visiEditPhone2: 'Telefon 2',
  visiEditPhoneHint: 'Ziffern ohne +',
  visiEditEmail1: 'E-Mail 1',
  visiEditEmail2: 'E-Mail 2',
  visiEditLatitude: 'Breitengrad',
  visiEditLongitude: 'Längengrad',
  visiEditNetwork: 'Netzwerk',
  visiEditHandleOrUrl: 'Handle oder URL',
  visiEditMediaHint: 'Logo und bis zu 4 Titelbilder. Neue Uploads ersetzen den Slot beim Speichern.',
  visiEditChooseLogo: 'Logo wählen',
  visiEditCoverSlot: 'Titelbild {n}',
  visiEditPaymentsHint: 'Wird auf deinem öffentlichen VISI angezeigt (nicht App-Store-Abrechnung).',
  visiEditDeleteWarning: 'Dies löscht das VISI dauerhaft.',
  visiEditBiography: 'Biografie',
  visiEditEdit: 'Bearbeiten',

  createVisiInstructionTitle: 'Erstelle dein VISI. Gib zuerst den Namen deiner Dienstleistung an.',
  createVisiNamePlaceholder: 'Mein VISI',
  createVisiButton: 'Erstellen',

  folderDefaultName: 'Liste',
  folderInvalidList: 'Ungültige Liste.',
  folderLoadFailed: 'Diese Liste konnte gerade nicht geladen werden.',
  folderOrganize: 'Organisieren',
  folderSelectVisisHint: 'VISIs zum Verschieben oder Entfernen auswählen',
  folderSelectedCount: '{n} ausgewählt',
  folderEmptyTitle: 'Keine VISIs in dieser Liste',
  folderEmptyBody: 'Füge Einträge aus Feed oder Suche hinzu.',
  noCategory: 'Keine Kategorie',
  folderRemoveFromListTitle: 'Aus Liste entfernen',
  folderRemoveConfirm: '{n} VISI aus dieser Liste entfernen?',
  folderRemoveConfirmMany: '{n} VISIs aus dieser Liste entfernen?',
  removing: 'Wird entfernt…',
  remove: 'Entfernen',
  folderMoveToListTitle: 'In Liste verschieben',
  folderNoOtherLists: 'Keine weiteren Listen verfügbar.',
  folderMoveFailed: 'Ausgewählte VISIs konnten nicht verschoben werden.',
  folderRemoveFailed: 'Ausgewählte VISIs konnten nicht entfernt werden.',
  folderMoveSelectedAria: 'Auswahl verschieben',
  folderRemoveSelectedAria: 'Auswahl entfernen',
  folderDoneOrganizingAria: 'Organisieren beenden',
  folderListNumber: 'Liste #{n}',

  settingsPaymentMethodsTitle: 'Zahlungsmethoden',
  settingsPaymentAddCard: 'Karte hinzufügen',
  settingsPaymentNoCards: 'Keine gespeicherten Karten',
  settingsPaymentRemoveCardAria: 'Karte entfernen',
  settingsPaymentAddCardTitle: 'Karte hinzufügen',
  settingsPaymentTokenHint: 'Gib das Karten-Token des Zahlungsanbieters ein (wie in der Mobile-App).',
  settingsPaymentCardTokenLabel: 'Karten-Token',
  settingsPaymentRemoveCardTitle: 'Karte entfernen',
  settingsPaymentRemoveCardBody: 'Diese Karte von deinem Konto entfernen?',
  settingsPaymentLoadFailed: 'Zahlungsmethoden konnten nicht geladen werden.',
  settingsPaymentAddFailed: 'Karte konnte nicht hinzugefügt werden.',
  settingsPaymentRemoveFailed: 'Karte konnte nicht entfernt werden.',
  settingsPaymentExpires: 'Läuft ab {month}/{year}',
  settingsPaymentDefault: 'Standard',

  settingsBillingAddressesTitle: 'Rechnungsadressen',
  settingsBillingAddAddress: 'Adresse hinzufügen',
  settingsBillingNoAddresses: 'Keine Rechnungsadressen',
  settingsBillingRemoveAddressAria: 'Adresse entfernen',
  settingsBillingNewAddressTitle: 'Neue Rechnungsadresse',
  settingsBillingRemoveAddressTitle: 'Adresse entfernen',
  settingsBillingRemoveAddressBody: 'Diese Rechnungsadresse entfernen?',
  settingsBillingLoadFailed: 'Rechnungsadressen konnten nicht geladen werden.',
  settingsBillingSaveFailed: 'Adresse konnte nicht gespeichert werden.',
  settingsBillingRemoveFailed: 'Adresse konnte nicht entfernt werden.',
  settingsBillingNameLabel: 'Name',
  settingsBillingStreetLabel: 'Strasse',
  settingsBillingCityLabel: 'Ort',
  settingsBillingZipLabel: 'PLZ',
  settingsBillingCountryLabel: 'Land',
  settingsBillingDefaultLabel: 'Standardadresse',
  settingsBillingSetDefault: 'Als Standard festlegen',

  changePasswordHint: '8–30 Zeichen mit Gross-/Kleinbuchstaben und Zahl oder Sonderzeichen.',
  changePasswordCurrent: 'Aktuelles Passwort',
  changePasswordNew: 'Neues Passwort',
  changePasswordConfirm: 'Neues Passwort bestätigen',
  changePasswordUpdate: 'Passwort aktualisieren',
  changePasswordSuccess: 'Passwort aktualisiert.',
  changePasswordFailed: 'Passwort konnte nicht geändert werden.',

  qrScanHint: 'Scannen, um dieses VISI-Profil zu öffnen',
  qrCopyLink: 'Link kopieren',
  qrOpenProfile: 'Profil öffnen',
  visiEditWebsitePlaceholder: 'https://…',

  privacyTitle: 'Datenschutz',
  privacyIntro: 'Verwalte, wie VisiMe mit deinen Daten umgeht.',
  privacyGroupYourData: 'Deine Daten',
  privacyDownloadData: 'Daten herunterladen',
  privacyDownloadDataSub: 'Export per E-Mail anfordern',
  privacyClearHistory: 'Suchverlauf löschen',
  privacyClearHistorySub: 'Letzte Suchanfragen entfernen',
  privacyGroupLegal: 'Rechtliches',
  privacyTermsOfService: 'Nutzungsbedingungen',
  privacyGroupAccount: 'Konto',
  privacyDeleteAccountSub: 'Profil öffnen, um dein Konto zu löschen',
  privacyLogoutDevice: 'Auf diesem Gerät abmelden',
  privacyDownloadSuccess: 'Falls deine E-Mail hinterlegt ist, erhältst du in Kürze Export-Anweisungen.',
  privacyDownloadFailed: 'Download-Anfrage fehlgeschlagen.',
  privacyHistoryCleared: 'Suchverlauf gelöscht.',
  privacyClearHistoryFailed: 'Verlauf konnte nicht gelöscht werden.',

  notificationSettingsLoadFailed: 'Mitteilungseinstellungen konnten nicht geladen werden.',
  notificationSettingsSaveFailed: 'Einstellungen konnten nicht gespeichert werden.',
  notificationPush: 'Push-Mitteilungen',
  notificationSms: 'SMS',
  notificationMarketing: 'Marketing',
  notificationMarketingHint: 'Optionen hängen von der Backend-Unterstützung für dein Konto ab.',
  saveSettings: 'Einstellungen speichern',

  advancedSearchTitle: 'Erweiterte Suche',
  advancedSearchSubtitle: 'Nach Stichworten, Kategorie und Standort filtern',
  advancedSearchKeywords: 'Stichworte',
  advancedSearchCategoryOptional: 'Kategorie (optional)',
  advancedSearchAny: 'Alle',
  advancedSearchLatitude: 'Breitengrad',
  advancedSearchLongitude: 'Längengrad',
  advancedSearchRadiusKm: 'Radius km',
  advancedSearchSort: 'Sortierung',
  advancedSearchSortDistance: 'Entfernung',
  advancedSearchSortName: 'Name',
  advancedSearchSortRecent: 'Neueste',
  advancedSearchRun: 'Suchen',
  advancedSearchFailed: 'Suche fehlgeschlagen',
  advancedSearchEmptyTitle: 'Keine Ergebnisse',
  advancedSearchEmptyBody: 'Andere Filter oder Stichworte versuchen.',

  reportRequestTitle: 'Anfrage',
  reportProblemTitle: 'Problem melden',
  reportRequestSubtitle: 'Sag uns, was wir verbessern oder ergänzen sollen.',
  reportProblemSubtitle: 'Beschreibe, was schiefgelaufen ist. Deine Nachricht geht an den VisiMe-Support.',
  supportCategory: 'Kategorie',
  reportPlaceholderRequest: 'Deine Anfrage…',
  reportPlaceholderProblem: 'Was ist passiert?',
  sending: 'Wird gesendet…',
  send: 'Senden',
  sentDefault: 'Gesendet.',
  supportLoadCategoriesFailed: 'Kategorien konnten nicht geladen werden',
  supportSendFailed: 'Senden fehlgeschlagen',

  notificationsLoadFailed: 'Laden fehlgeschlagen',
  notificationFallback: 'Update',

  locationSettingsTitle: 'Standort',
  locationSettingsIntro:
    'Lege fest, wie VisiMe Entfernungen im Web misst — wie der Standort-Picker in der App. Netzwerk-Standort nutzt deine öffentliche IP (ISP / Stadt), wenn du kein GPS teilst.',
  locationModeGps: 'Gerätestandort (GPS) nutzen',
  locationModeIp: 'Ungefähren Netzwerkstandort (ISP / IP) nutzen',
  locationModeFixed: 'Feste Adresse nutzen',
  locationUpdating: 'Wird aktualisiert…',
  locationGpsUnavailable: 'Gerätestandort nicht verfügbar — Home nutzt Netzwerk-Näherung oder Zürich.',
  locationUsingGps: 'Geräte-GPS wird verwendet, wenn verfügbar.',
  locationIpFailed: 'Netzwerkstandort konnte nicht ermittelt werden. Erneut versuchen oder feste Adresse wählen.',
  locationUsingIp: 'Ungefährer Netzwerkstandort (ISP) — nur Stadt-Ebene.',
  locationPickFixed: 'Stadt oder Adresse unten wählen.',
  locationFixedSaved: 'Fester Standort für Entfernungssortierung gespeichert.',
  locationZurichDefault: 'Bahnhofstrasse, Zürich (Standard wie in der App).',
  locationSearchLabel: 'Stadt oder Adresse suchen',
  locationSearchPlaceholder: 'z. B. Zürich, Bahnhofstrasse',
  locationUseZurich: 'Bahnhofstrasse, Zürich verwenden',
  locationSearching: 'Suche…',
  locationActiveForHome: 'Aktiv für Home-Entfernung: {label}',
  locationSaved: 'Gespeichert: {address}',
  locationCurrentAddress: 'Aktueller Standort',

  mapLocating: 'Standort wird ermittelt…',
  mapAuthRequired: 'Melde dich an, um Betriebe in der Nähe auf der Karte zu sehen.',
  mapFixedEmpty: 'Keine Betriebe mit fester Adresse innerhalb 10 km.',
  mapFixedCountLocal: '{count} Betriebe mit fester Adresse innerhalb 10 km',
  mapLoadFailed: 'Karte konnte nicht geladen werden. Bitte erneut versuchen.',
  settingsNearbyMap: 'Karte in der Nähe',
  settingsNearbyMapSub: 'Betriebe mit fester Adresse innerhalb 10 km',

  mapsSettingsIntro: 'Bevorzugte Karten-App für Adressen (auf diesem Gerät gespeichert).',
  mapsApple: 'Apple Karten',
  mapsGoogle: 'Google Maps',

  feedTabVisi: 'VISI-Feed',
  feedTabNotification: 'Mitteilungen',

  profileLoading: 'Laden…',
  brandName: 'VisiMe',
  languageAria: 'Sprache',
  settingsAria: 'Einstellungen',
  loadingFeedAria: 'Feed wird geladen',
  primaryNavAria: 'Hauptnavigation',
  visiShellTitle: 'VISI',
  visiEditPaypalLabel: 'PayPal',
  socialFacebookAria: 'Facebook',
  socialInstagramAria: 'Instagram',
  socialXAria: 'X',
  headerNotificationsAria: 'Mitteilungen',
  searching: 'Suche…',
  registerConfirmPassword: 'Passwort bestätigen',
  discoverNoBusinessesTitle: 'Keine Unternehmen',
  discoverNoBusinessesBody: 'Aktualisiere, um neue Vorschläge zu laden',
  discoverRefresh: 'Aktualisieren',
  discoverRefreshAria: 'Entdecken-Feed aktualisieren',
  discoverSectionLabel: 'Entdecken',
  notificationsUpdatesTitle: 'Neuigkeiten',
  notificationsEmptyListBody: 'Favoriten in deinen Listen erscheinen hier als Neuigkeiten.',
  mapsDefaultMaps: 'Standard-Karten',
  folderDragReorderAria: 'Zum Sortieren ziehen',
  folderOrganizeDragHint: 'Ziehen zum Sortieren oder VISIs zum Verschieben/Entfernen auswählen',
  folderSavingOrder: 'Reihenfolge wird gespeichert…',
  visiEditTwintLabel: 'Twint',
  advancedSearchRunAria: 'Erweiterte Suche ausführen',
  goBack: 'Zurück',
  landingMenuTitle: 'Menü',
  landingMenuOpenAria: 'Menü',
  landingCloseAria: 'Schliessen',
  landingBillingToggleAria: 'Abrechnung',
  landingGetStartedEyebrow: 'Jetzt loslegen',
  landingFooterNavigationHeading: 'NAVIGATION',
  landingFooterUsefulLinksHeading: 'NÜTZLICHE LINKS',
  landingPlanVisiSingle: 'VISI Single',
  landingPlanVisiDuo: 'VISI Duo',
  landingPlanVisiPromoter: 'VISI Promoter',
  profileDemoName: 'Beispielprofil',
  profileDemoTitle: 'Beispiel-Beruf',
  profileDemoDescription: 'Platzhalterprofil für Entwicklungsvorschau.',

  waitlistMetaTitle: 'VisiMe Warteliste',
  waitlistMetaDescription:
    'Trag dich mit deiner E-Mail in die VisiMe Warteliste ein und teile deinen Einladungslink.',
  waitlistEyebrow: 'Early Access',
  waitlistTitle: 'Auf die Warteliste',
  waitlistLead:
    'Hinterlasse deine E-Mail. Wir speichern sie nur für die Warteliste — es wird keine Mail verschickt. Empfehle Freunde und steige in der Rangliste auf.',
  waitlistBackHome: 'Zur Startseite',
  waitlistEmailLabel: 'E-Mail-Adresse',
  waitlistEmailPlaceholder: 'name@example.com',
  waitlistSubmit: 'Eintragen',
  waitlistSubmitting: 'Wird gespeichert…',
  waitlistInvalidEmail: 'Bitte gib eine gültige E-Mail-Adresse ein.',
  waitlistConnectionError: 'Verbindung fehlgeschlagen. Bitte versuche es erneut.',
  waitlistGenericError: 'Eintrag in die Warteliste fehlgeschlagen. Bitte versuche es erneut.',
  waitlistRestoring: 'Lade deinen Platz…',
  waitlistInviteActive: 'Einladung aktiv — Code {code}',
  waitlistAlreadyKicker: 'Du bist schon dabei',
  waitlistWelcomeKicker: 'Willkommen auf der Liste',
  waitlistBucketTop1: 'Top 1%',
  waitlistBucketTop10: 'Top 10%',
  waitlistBucketTop50: 'Top 50%',
  waitlistBucketInList: 'Auf der Warteliste',
  waitlistHintTop1: 'Du bist unter den ersten Prozent — starker Start.',
  waitlistHintTop10: 'Du bist unter den besten 10%. Jede Empfehlung hilft weiter nach oben.',
  waitlistHintTop50: 'Du bist in der oberen Hälfte. Teile deinen Link und steige auf.',
  waitlistHintInList: 'Du bist auf der Liste. Empfehle VisiMe und verbessere deinen Platz.',
  waitlistReferralCountOne: '{n} erfolgreiche Empfehlung',
  waitlistReferralCountMany: '{n} erfolgreiche Empfehlungen',
  waitlistShareTitle: 'Dein Einladungslink',
  waitlistShareLead: 'Freunde, die über deinen Link beitreten, schieben dich nach oben.',
  waitlistShareInputAria: 'Einladungslink',
  waitlistCopy: 'Kopieren',
  waitlistShare: 'Link teilen',
  waitlistCodePrefix: 'Code:',
  waitlistCopied: 'Link kopiert — teile ihn mit Freunden.',
  waitlistCopyFailed: 'Kopieren fehlgeschlagen.',
  waitlistShareNativeTitle: 'VisiMe Warteliste',
  waitlistShareNativeText: 'Komm auf die VisiMe Warteliste — mit meinem Link steigst du mit ein:',
  waitlistHowTitle: 'So funktioniert’s',
  waitlistHowStep1: 'Mit E-Mail eintragen',
  waitlistHowStep2: 'Persönlichen Einladungslink teilen',
  waitlistHowStep3: 'Aufsteigen, wenn Freunde mitmachen',
  waitlistAlreadyAccount: 'Schon dabei?',
  waitlistSignIn: 'Anmelden',
  waitlistCtaShort: 'Warteliste',
  waitlistCtaLong: 'Zur Warteliste',
  waitlistThemeLightAria: 'Hellen Modus aktivieren',
  waitlistThemeDarkAria: 'Dunklen Modus aktivieren',
  marketingNavApp: 'Die App',
  marketingNavVisi: 'VISI',
  marketingNavMe: 'ME',
  marketingNavPricing: 'Preisplan',
  marketingNavWaitlist: 'Warteliste',
  marketingNavSupport: 'Support',
};

export type StringKey = keyof typeof en;

const catalogs = { en, de } as const;

export function t(key: StringKey, vars?: Record<string, string | number>, lang?: string): string {
  const code = (lang === 'de' || lang === 'en' ? lang : getApiLanguage()) as 'en' | 'de';
  let s: string = catalogs[code][key] ?? catalogs.en[key] ?? key;
  if (vars) {
    for (const [k, v] of Object.entries(vars)) {
      s = s.replace(`{${k}}`, String(v));
    }
  }
  return s;
}
